import React from 'react';
import { Message } from 'semantic-ui-react';

interface Props {
  errors: any;
}

const ValidationError: React.FC<Props> = ({ errors }) => {
  return (
    <Message error>
      {errors.length && (
        <Message.List>
          {errors.map((err: any, idx: any) => (
            <Message.Item key={idx}>{err}</Message.Item>
          ))}
        </Message.List>
      )}
    </Message>
  );
};

export { ValidationError };
